import React from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';
import { LinkedIn, GitHub, Email } from '@material-ui/icons';
import resumeData from '../../utils/resume-data';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        background: 'black',
    },
    paper: {
        padding: theme.spacing(2),
        width: '100%',
        height: '3rem',
        background: 'black',
    },
    footer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        position: "fixed",
        background: 'black',
        bottom: "0",
        left: "0",
        width: "100%",
        height: "5%",
        borderTop: '2px',
        borderColor: '#ccc',
        zIndex: 2,
        padding: '2rem',
        '@media (max-width:600px)': {
            position: "sticky",
            flexWrap: 'wrap',
        },
    },
    icons: {
        color: "whitesmoke",
        fontSize: 25,
        '@media (min-width:1200px)': {
            fontSize: '1.8rem',
        },
    },
    // translate: {
    //     '@media (max-width:600px)': {
    //         paddingTop: '1rem',
    //     },
    //     "& .goog-te-combo, .goog-te-banner *, .goog-te-ftab *, .goog-te-menu *, .goog-te-menu2 *, .goog-te-balloon *": {
    //         color: 'white',
    //         background: 'black',
    //     },
    //     "& .skiptranslate, .goog-te-gadget, .goog-logo-link,": {
    //         color: 'orange',
    //     },
    // }
}));

const Footer = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Hidden only={['xl', 'lg']}>
                <div className={classes.paper}></div>
            </Hidden>
            <footer className={classes.footer}>
                <Button
                    href={resumeData.linkedin}
                    rel="noopener"
                    aria-label="LinkedIn"
                    target="_blank"
                    className={classes.icons}>
                    <LinkedIn className={classes.icons} />
                </Button>
                <Button
                    href={resumeData.github}
                    rel="noopener"
                    target="_blank"
                    aria-label="Github"
                    className={classes.icons}>
                    <GitHub className={classes.icons} />
                </Button>
                <Button
                    href="/contact"
                    aria-label="contact-section"
                    className={classes.icons}>
                    <Email className={classes.icons} />
                </Button>
                {/* <div rel="noopener" id="google_translate_element" className={classes.translate}></div> */}
            </footer>
        </div>
    );
};

export default Footer

